import { Lesson } from '../domain/types';

export const lessons: Lesson[] = [
  {
    id: 'spelling-1',
    title: 'Aprende tu nombre - Arrastra',
    mode: 'spelling',
    description: 'Arrastra las letras C-A-T-A-L-E-Y-A a su lugar',
    icon: '🔤',
    completed: false
  },
  {
    id: 'spelling-2', 
    title: 'Aprende tu nombre - Traza',
    mode: 'spelling',
    description: 'Traza las letras C-A-T-A-L-E-Y-A con tu dedo',
    icon: '✏️',
    completed: false
  },
  {
    id: 'math-1',
    title: 'Sumas fáciles',
    mode: 'math',
    description: 'Suma objetos hasta 3',
    icon: '🌸',
    completed: false
  },
  {
    id: 'math-2',
    title: 'Sumas medias',
    mode: 'math', 
    description: 'Suma objetos hasta 4',
    icon: '👑',
    completed: false
  },
  {
    id: 'math-3',
    title: 'Sumas difíciles',
    mode: 'math',
    description: 'Suma objetos hasta 5',
    icon: '💎',
    completed: false
  },
  {
    id: 'math-4',
    title: 'Sumas súper difíciles',
    mode: 'math',
    description: 'Suma objetos hasta 6',
    icon: '🦄',
    completed: false
  },
  {
    id: 'math-5',
    title: 'Sumas expertas',
    mode: 'math',
    description: 'Suma objetos hasta 7',
    icon: '⭐',
    completed: false
  }
];

export const getLessons = (): Lesson[] => {
  return lessons;
};
